import { createReducer, on } from '@ngrx/store';
import {
  ustawWidocznoscWarstwy,
  ustawWszystkieWidocznosci,
  wyczyscWidocznosciWarstw
} from './warstwy-dodatkowe.actions';
import { initialWarstwyDodatkoweState } from './warstwy-dodatkowe.state';

export const warstwyDodatkoweReducer = createReducer(
  initialWarstwyDodatkoweState,

  on(ustawWidocznoscWarstwy, (state, { uuid, widoczna }) => {
    if (widoczna) {
      return {
        ...state,
        widocznosci: {
          ...state.widocznosci,
          [uuid]: true
        }
      };
    }

    const widocznosci = { ...state.widocznosci };
    delete widocznosci[uuid];

    return {
      ...state,
      widocznosci
    };
  }),

  on(ustawWszystkieWidocznosci, (state, { widocznosci }) => ({
    ...state,
    widocznosci: Object.fromEntries(
      Object.entries(widocznosci)
        .filter(([, value]) => value)
    )
  })),

  on(wyczyscWidocznosciWarstw, (state) => ({
    ...state,
    widocznosci: {}
  }))

);
